import { render, staticRenderFns } from "./EditBookable.vue?vue&type=template&id=57150a83&scoped=true&"
import script from "./EditBookable.vue?vue&type=script&lang=js&"
export * from "./EditBookable.vue?vue&type=script&lang=js&"
import style0 from "./EditBookable.vue?vue&type=style&index=0&id=57150a83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57150a83",
  null
  
)

export default component.exports